/**
 * The badge for `analysisStatusPresentation` — the one place the tone/word
 * pairing turns into markup, so the list, the Analysis page and the wizard
 * render the exact same badge.
 */
import { Box } from '@mui/material';
import {
	analysisStatusPresentation,
	TONE_GLYPH,
	TONE_TO_BADGE,
	type AnalysisStatusInput,
} from './analysisStatusPresentation';

export function AnalysisStatusTag({
	row,
	help,
	glyph = false,
}: {
	row: AnalysisStatusInput;
	/** Shown as a tooltip — the blocked reason or the failure message, when the
	 *  caller has one short enough to fit in a title attribute. */
	help?: string | null;
	/** Prefix the word with its tone's glyph ("✓ Ready", "⚠ Blocked"). */
	glyph?: boolean;
}) {
	const { label, tone } = analysisStatusPresentation(row);
	const mark = glyph ? TONE_GLYPH[tone] : undefined;
	return (
		<Box
			component="span"
			className={`bdg ${TONE_TO_BADGE[tone]}`}
			title={help || undefined}
		>
			{mark ? `${mark} ${label}` : label}
		</Box>
	);
}
